module.exports = __webpack_public_path__ + "img/fondo-cta-empresas.a4c9d5f.webp";